module.exports = __webpack_public_path__ + "media/images/mission_icon_6-37bed280b6199b4aa932293597f8e15b.svg";